import React from "react";
import mwhLogo from "../../assets/images/MWHLogo.png";
import { LOGIN_PAGE } from "../../helpers/constants/Constants";

const loginRedirect = LOGIN_PAGE;

const AccessDenied = () => {
  return (
    <div className="accessDeniedComp accessDeniedComp--modern">
      <div className="accessDeniedCard accessDeniedCard--modern">
        <div className="titleSpace accessDeniedCard__titleSpace">
          <h1>Access Required</h1>
        </div>
        <div className="paraSpace accessDeniedCard__paraSpace">
          <p>You need to sign in to gain access to this page.</p>
        </div>
        <div className="buttonSpace accessDeniedCard__buttonSpace">
          <a className="accessDeniedCard__loginLink" href={loginRedirect}>
            <button className="bttn accessDeniedCard__actionBtn">
              Return to Login
            </button>
          </a>
        </div>
        <div className="logoSpace accessDeniedCard__logoSpace">
          <img src={mwhLogo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
